import React from 'react';
import PropTypes from 'prop-types';
import { ThemeProvider, ApplyTheme } from '.';
import { localTheme as sendPaymentsTheme } from '../../themes/sendpayments';
import { localTheme as travelMoneyTheme } from '../../themes/travel-money-transfers';

import { appBreakpoints } from '../MediaBreakpoint';

function getTheme(themeName) {
  switch (themeName) {
    case 'sendpayments':
      return sendPaymentsTheme;
    case 'travel-money-transfers':
      return travelMoneyTheme;
    default:
      return sendPaymentsTheme;
  }
}

/**
 * @param {{ children: any; name: string; }} props
 */
const SendPaymentsTheme = ({ children, name }) => (
  <ThemeProvider name={`Test-${name}`} localTheme={getTheme(name)} overrideBreakpoints={appBreakpoints}>
    {<ApplyTheme>{children}</ApplyTheme>}
  </ThemeProvider>
);

SendPaymentsTheme.propTypes = {
  children: PropTypes.node.isRequired,
  name: PropTypes.string.isRequired,
  theme: PropTypes.string.isRequired,
};

export default SendPaymentsTheme;
